import { AccordionHeader } from '@vds-core/accordions';
export default AccordionHeader;